import React from 'react';
import {connect} from 'react-redux';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from "@material-ui/core/IconButton";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Switch from '@material-ui/core/Switch';
import Avatar from '@material-ui/core/Avatar';
import {
    DriveEta as DriveEtaIcon,
    ExitToApp as ExitToAppIcon,
    Person as PersonIcon,
    Settings as SettingsIcon
} from "@material-ui/icons";
import * as actions from "../store/actions";
import {useHistory} from "react-router-dom";
import MenuIcon from "@material-ui/icons/Menu";
import SpeedIcon from "@material-ui/icons/Speed";
import NotListedLocationIcon from '@material-ui/icons/NotListedLocation';
import {Box} from "@material-ui/core";
import DrawerFooter from "./DrawerFooter";
import capitalize from "@material-ui/core/utils/capitalize";

const useStyles = makeStyles((theme) => ({
    list: {
        width: 250
    },
    fullList: {
        width: 'auto',
    },
    header: {
        marginRight: theme.spacing(2),
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    avatar: {
        background: theme.palette.primary.main,
        color: "white",
        fontWeight: "bold",
        marginBottom: '16px'
    },
    icon: {
        color: '#96979C'
    },
    IconButton: {
        padding: 'inherit',
        marginRight: '12px',
        marginTop: '50px'
    },
    drawer: {
        left: 'auto',
        right: 0,
        top: '100px'
    }
}));

const SettingsDrawer = (props) => {

    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const history = useHistory();

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpen(open);
    };

    const logoutHandler = () => {
        props.onLogout(redirect => {

            if (redirect)
                history.push(redirect)
        });
    }

    const changeMode = () => {
        props.onChangeDarkMode(!props.darkMode)
    };
    const userName = [];
    if (props.account && props.account.firstName) {
        userName.push(props.account.firstName);
    }
    if (props.account && props.account.lastName) {
        userName.push(props.account.lastName);
    }


    const list = (
        <ClickAwayListener onClickAway={toggleDrawer(false)}>
            <div
                className={clsx(classes.list)}
                role="presentation"
                onKeyDown={toggleDrawer(false)}

            >
                <div className={classes.header}>
                    <Avatar
                        className={classes.avatar}>{(props.account && props.account.firstName) ? capitalize(props.account.firstName).charAt(0) : "D"}</Avatar>
                    <Box style={{
                        fontSize: '20px',
                        color: '#00AEEF',
                        fontWeight: "bold"
                    }}>{userName.length > 0 ? capitalize(userName.join(' ')) : ''}</Box>
                    <Box style={{fontSize: '12px', lineHeight: '12px'}}>
                        {(props.account && props.account.email) ? props.account.email : ''}
                    </Box>
                </div>

                <Divider/>
                <List>
                    {false && <ListItem button>
                        <ListItemIcon style={{marginLeft: '-16px', marginRight: '16px'}}><Switch
                            checked={props.darkMode}
                            onChange={changeMode}
                            color={"primary"}
                            name="checkedA"
                            inputProps={{'aria-label': 'primary checkbox'}}

                        /></ListItemIcon>
                        <ListItemText primary={'Dark Mode'}/>
                    </ListItem>
                    }

                    <ListItem button onClick={() => {
                        setOpen(false)
                        history.push('/dashboard/promo')
                    }}>
                        <ListItemIcon><NotListedLocationIcon className={classes.icon}/></ListItemIcon>
                        <ListItemText primary={'Why Carwiser?'}/>
                    </ListItem>

                    <ListItem button onClick={() => {
                        setOpen(false)
                        history.push('/dashboard')
                    }}>
                        <ListItemIcon><SpeedIcon className={classes.icon}/></ListItemIcon>
                        <ListItemText primary={'My Dashboard'}/>
                    </ListItem>

                    <ListItem button onClick={() => {
                        setOpen(false)
                        history.push('/dashboard/account')
                    }}>
                        <ListItemIcon><PersonIcon className={classes.icon}/></ListItemIcon>
                        <ListItemText primary={'Account Profile'}/>
                    </ListItem>

                    <ListItem button onClick={() => {
                        setOpen(false)
                        history.push('/dashboard/vehicle')
                    }}>
                        <ListItemIcon><DriveEtaIcon className={classes.icon} fontSize={'small'}/></ListItemIcon>
                        <ListItemText primary={'My Vehicles'}/>
                    </ListItem>


                </List>
                <Divider/>
                <List>
                    <ListItem button onClick={() => {
                        setOpen(false)
                        history.push('/dashboard/settings')
                    }}>
                        <ListItemIcon><SettingsIcon className={classes.icon}/></ListItemIcon>
                        <ListItemText primary={'Settings'}/>
                    </ListItem>

                    <ListItem button onClick={logoutHandler}>
                        <ListItemIcon><ExitToAppIcon className={classes.icon} fontSize={'small'}/></ListItemIcon>
                        <ListItemText primary={'Log Out'}/>
                    </ListItem>

                </List>
                <DrawerFooter/>
            </div>

        </ClickAwayListener>
    );

    return (
        <React.Fragment>
            <IconButton edge="start" color="primary" aria-label="menu" onClick={toggleDrawer(true)} className={classes.IconButton}>
                <MenuIcon />
            </IconButton>
            <div>
                <Drawer anchor={'right'} open={open} onClose={toggleDrawer(false)} classes={{ paperAnchorRight: classes.drawer }}>
                    {list}
                </Drawer>
            </div>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return {
        darkMode: state.app.darkMode,
        account: state.account
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onChangeDarkMode: (state) => dispatch(actions.setDarkMode(state)),
        onLogout: (onRedirect) => dispatch(actions.logout(onRedirect))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsDrawer);